(function () {
    "use strict";
    angular
        .module("showcaseApp")
        .component("customerEditForm", {
            bindings: {
                customer: "=",
                loading: "<",
                showclose: "<",
                profilePicture: "<",
                platform: "<",
                onClose: "&",
                onExpose: "&"
            },
            controller: CustomerEditFormController,
            controllerAs: "vm",
            templateUrl:
                "app/admin/customer/customer-edit-form/customer-edit-form.html",
        });

    /** @ngInject */
    function CustomerEditFormController(
        $translate,
        moment,
        NoteTagService,
        toastr,
        CustomerService,
        $scope,
        $localStorage,
        $timeout,
        UserService,
        $q
    ) {
        var vm = this;
        vm.$onInit = function () {
            if (vm.onExpose) {
                vm.onExpose({
                    methods: {
                        applyFilters: vm.applyFilters,
                        closeModal: vm.closeModal,
                        isFormInvalid: vm.isFormInvalid,
                        save: vm.saveEditCustomer
                    }
                });
            }
        };

        vm.applyFilters = function () {
            vm.saveEditCustomer();
        };

        var DATETIME_FORMAT = $translate.instant('momentDateTime24HFormat');
        vm.DATE_FORMAT = $translate.instant('momentDateFormat');
        var TAG_NOTE_MAP = {
            TAG: 'tag',
            NOTE: 'note'
        };

        vm.isMobile = detectar_mobile();
        vm.mainColor = getComputedStyle(
            document.documentElement
        ).getPropertyValue("--main-color");
        vm.isEditMode = false;
        vm.newTagText = "";
        vm.tags = [];
        vm.storeTags = [];
        vm.filteredStoreTags = [];
        vm.notes = [];
        vm.isEditingNote = false;
        vm.isWritingNote = false;
        vm.pendingTagsToCreate = [];
        vm.showMoreOptions = false;
        vm.searchQuery = '';
        vm.tagDropdownOpen = false;
        vm.tagDropdownStyle = {};

        $scope.$watch('vm.tagDropdownOpen', function(isOpen) {
            if (!isOpen) return;
            $timeout(function() {
                var wrapEl = document.querySelector('.custom-tag-autocomplete .tag-input-wrap');
                var containerEl = document.querySelector('.customer-info');
                if (wrapEl && containerEl) {
                    var wrapRect = wrapEl.getBoundingClientRect();
                    var containerRect = containerEl.getBoundingClientRect();
                    vm.tagDropdownStyle = {
                        position: 'absolute',
                        top: (wrapRect.bottom - containerRect.top + 4) + 'px',
                        left: (wrapRect.left - containerRect.left) + 'px',
                        width: wrapRect.width + 'px',
                        'z-index': 1100
                    };
                }
            });
        });

        vm.init = function () {
            loadGenders();
            vm.isCreateMode = !vm.customer || !vm.customer.id;
            vm.isEditMode = vm.isCreateMode;

            loadCustomerData();

            vm.dontScrolled = true;
            vm.conversationHeight = window.innerHeight - 71;
        };

        $scope.$watch('vm.customer.id', function (newId, oldId) {
            if (newId && newId !== oldId) {
                vm.isCreateMode = false;
                vm.isEditMode = false;
                loadCustomerData();
            }
        });

        vm.close = function (result) {
            if (vm.onClose) {
                vm.onClose({ customer: result });
            }
        };

        vm.goToElement = function (element) {
            if (element === "listConversations") {
                vm.currentConversation = {};
            }
            changeMobileFlow(element);
        };

        vm.isFormInvalid = function () {
            return vm.editCustomerForm && vm.editCustomerForm.$invalid;
        };

        function addNine(numberWithNine) {
            if (numberWithNine && numberWithNine.includes('+55') && numberWithNine.length === 13) {
                numberWithNine = numberWithNine.slice(0, 5) + '9' + numberWithNine.slice(5, numberWithNine.length);
            }
            return numberWithNine;
        }

        vm.toEditMode = function () {
            if (!vm.isEditMode) {
                vm.isEditMode = true;
                vm.customerEdit = angular.copy(vm.customer);
                vm.customerEdit.phone = addNine(vm.customerEdit.phone);
                if(vm.customer.zipCode) {
                    vm.customerEdit.zipcode = vm.customer.zipCode;
                }
            }
        };

        vm.onCancel = function () {
            if (vm.isCreateMode) {
                vm.close();
            }
            vm.cancelEditMode();
        };

        vm.cancelEditMode = function () {
            vm.customerEdit = {};
            vm.isEditMode = false;
            vm.showMoreOptions = false;
        };

        vm.saveEditCustomer = function () {
            var customerToSave = angular.copy(vm.customerEdit);

            if (customerToSave.gender === 'MALE') {
                customerToSave.gender = 'messages.gender.male';
            } else if (customerToSave.gender === 'FEMALE'){
                customerToSave.gender = 'messages.gender.female';
            }
            customerToSave.birthDate = vm.customerEdit.birthDateText
                ? moment(vm.customerEdit.birthDateText, vm.DATE_FORMAT).toISOString()
                : null;
            customerToSave.zipCode = customerToSave.zipcode;
            if(vm.isCreateMode) {
                saveCustomer(customerToSave);
            } else {
                updateCustomer(customerToSave);
            }
        };

        vm.addressFormat = function () {
            var zipcode;
            if(vm.customer.zipcode) {
                zipcode = vm.customer.zipcode;
            } else {
                zipcode = vm.customer.zipCode;
            }
            var address = vm.customer.address;
            var state = vm.customer.state;
            var city = vm.customer.city;
            var addressNumber = vm.customer.addressNumber;
            var complement = vm.customer.complement;
            var district = vm.customer.district;

            if (!zipcode && !address && !state && !city && !addressNumber) {
                return $translate.instant("communication.no-information");
            }

            return (
                (address ? address + (addressNumber ? ", " : " ") : "") +
                (addressNumber ? addressNumber + (district ? ", " : (city ? " - " : " ")) : "") +
                (district ? district + (city ? ", " : " ") : "") +
                (city ? city + (state ? " - " : " ") : "") +
                (state ? state + (zipcode ? ", " : " ") : "") +
                (zipcode ? zipcode : "") +
                (complement ? " - " + complement : "")
            );
        };

        vm.checkTagExists = function(text) {
            if (!text || !vm.tags || vm.tags.length === 0) {
                angular.element(document.querySelector('.add-tag input')).removeClass('input-error');
                return false;
            }

            var exists = vm.tags.some(function(tag) {
                return tag.text.toLowerCase() === text.trim().toLowerCase();
            });

            var input = angular.element(document.querySelector('.add-tag input'));
            exists ? input.addClass('input-error') : input.removeClass('input-error');

            return exists;
        };

        vm.createUpdateNoteTag = function (newNoteTagText, isTag) {
            if (vm.isEditingNote) {
                NoteTagService.updateNote({
                    noteId: vm.currentlyEditingNote,
                    text: newNoteTagText,
                }).then(function (result) {
                    for (var i = 0; i < vm.notes.length; i++) {
                        if (vm.notes[i].id == vm.currentlyEditingNote) {
                            vm.notes[i].text = result.text;
                            break;
                        }
                    }
                });
            } else {
                NoteTagService.createNoteTag({
                    customerId: vm.customer.id,
                    text: newNoteTagText,
                    type: isTag ? TAG_NOTE_MAP.TAG : TAG_NOTE_MAP.NOTE,
                }).then(function (result) {
                    result.timestamp = moment(result.timestamp).format(DATETIME_FORMAT);

                    if (isTag) {
                        vm.tags.push(result);
                        vm.newTagText = "";
                    } else {
                        vm.notes.push(result);
                        vm.newNoteText = "";
                    }
                });
            }
        };

        vm.resetFormState = function() {
            var inputElement = document.querySelector('md-autocomplete input');
            if (inputElement) inputElement.blur();

            vm.isWritingNote = false;
            vm.isEditingNote = false;
            vm.searchQuery = "";
            vm.newTagText = "";
        };

        /**
         * adds a new tag or note to the user
         * @param {the text of the tag that's being created} newNoteTagText
         * @param {is true if it's suppose to add a tag} isTag
         */
        vm.addNoteTag = function (newNoteTagText, isTag) {
            if (newNoteTagText === "" || newNoteTagText === null) {
                toastr.warning($translate.instant('entity.validation.blank-text'));
                return;
            }

            var trimmedText = newNoteTagText.trim();
            var normalizedTrimmedText = normalizeText(trimmedText);

            var tagExistsInTags = vm.tags.some(function(tag) {
                return tag.text && normalizeText(tag.text) === normalizedTrimmedText;
            });

            var tagExistsInPending = vm.pendingTagsToCreate.some(function(tag) {
                return tag.text && normalizeText(tag.text) === normalizedTrimmedText;
            });

            if (tagExistsInTags || tagExistsInPending) {
                toastr.warning($translate.instant('entity.validation.duplicated-label'));
                return;
            }

            if (vm.isCreateMode) {
                vm.pendingTagsToCreate.push({
                    text: trimmedText,
                    type: isTag ? TAG_NOTE_MAP.TAG : TAG_NOTE_MAP.NOTE
                });

                if (isTag) {
                    vm.tags.push({ text: trimmedText });
                    vm.newTagText = "";
                } else {
                    vm.notes.push({ text: trimmedText });
                    vm.newNoteText = "";
                }
            } else {
                vm.createUpdateNoteTag(trimmedText, isTag);
            }

            var inputElement = document.querySelector('md-autocomplete input');
            if (inputElement) {
                inputElement.blur();
            }

            vm.isWritingNote = false;
            vm.isEditingNote = false;
            vm.searchQuery = "";
            vm.newTagText = "";
        };

        vm.closeTagDropdown = function() {
            $timeout(function() {
                vm.tagDropdownOpen = false;
            }, 150);
        };

        vm.onSelectTag = function(selectedTag) {
            if (selectedTag) {
                vm.addNoteTag(selectedTag.text, true);
                vm.tagDropdownOpen = false;
            }
        };

        /**
         * deletes a not or a tag
         * @param {the tag id} tagId
         * @param {is true if it's suppose to delete a tag} isTag
         */
        vm.deleteNoteTag = function (tagId, isTag) {
            NoteTagService.deleteNoteTag(tagId).then(function () {
                isTag
                    ? (vm.tags = vm.tags.filter(function (value) {
                        return value.id !== tagId && value.type === TAG_NOTE_MAP.TAG;
                    }))
                    : (vm.notes = vm.notes.filter(function (value) {
                        return value.id !== tagId && value.type === TAG_NOTE_MAP.NOTE;
                    }));
            });
        };

        vm.startWritingNote = function (isEditingNote, noteId, index) {
            if (isEditingNote) {
                vm.newNoteText = vm.notes[index].text;
            }

            vm.isWritingNote = true;
            vm.isEditingNote = isEditingNote;
            vm.currentlyEditingNote = noteId;
        };

        vm.stopWritingNote = function () {
            vm.newNoteText = "";
            vm.isWritingNote = false;
            vm.isEditingNote = false;
        };

        function changeMobileFlow(source) {
            if (detectar_mobile()) {
                Object.keys(vm.mobileFlow).map(function (item) {
                    vm.mobileFlow[item] = source === item ? true : false;
                });
            }
        }

        vm.querySearchTag = function(query) {
            if (!query || query.trim() === '') {
                return vm.filteredStoreTags || [];
            }

            var searchTerm = normalizeText(query.trim());

            return (vm.filteredStoreTags || []).filter(function(tag) {
                return tag.text &&
                    normalizeText(tag.text).includes(searchTerm);
            });
        };

        vm.getGenderKey = function (value) {
            return 'customer.' + value;
        }

        function normalizeText(text) {
            return text
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '')
                .toLowerCase();
        }

        function loadGenders() {
            UserService.listUserGenders().then(function (genders) {
                vm.genders = genders.map(function (item) {
                    return {
                        key: item.key,
                        value: item.value,
                        label: $translate.instant(vm.getGenderKey(item.key))
                    };
                });
            });
        }

        function saveCustomer(customer) {
            customer.storeId = $localStorage.defaultStore.storeId;
            customer.type = "INDIVIDUAL";
            CustomerService.create(customer).then(function (result) {
                toastr.success($translate.instant('customer.created'));
                vm.customer = result.data;
                if(vm.customer.birthDate) {
                    vm.customer.birthDateText = moment.utc(vm.customer.birthDate).format(vm.DATE_FORMAT).toString();
                }

                if (vm.pendingTagsToCreate.length > 0) {
                    createTagsForCustomer(vm.customer.id, vm.pendingTagsToCreate).then(function() {
                        vm.pendingTagsToCreate = [];
                        $timeout(function() {
                            vm.close(vm.customer);
                        }, 0);
                    });
                } else {
                    $timeout(function() {
                        vm.close(vm.customer);
                    }, 0);
                }
            }, function (error) {
                if (error.data.headers["x-adminapp-params"]) {
                    toastr.error($translate.instant(error.data.headers["x-adminapp-params"].concat(".").concat(error.data.headers["x-adminapp-error"])));
                } else {
                    toastr.error($translate.instant("global.messages.somethingWrong"));
                }
            });
        }

        function createTagsForCustomer(customerId, tags) {
            var promises = [];

            tags.forEach(function(tag) {
                var promise = NoteTagService.createNoteTag({
                    customerId: customerId,
                    text: tag.text,
                    type: tag.type
                }).then(function(resultTag) {
                    resultTag.timestamp = moment(resultTag.timestamp).format(DATETIME_FORMAT);

                    if (tag.type === TAG_NOTE_MAP.TAG) {
                        vm.tags.push(resultTag);
                    } else {
                        vm.notes.push(resultTag);
                    }
                });

                promises.push(promise);
            });

            return $q.all(promises);
        }

        function updateCustomer(customer) {
            CustomerService.update(customer).then(function (result) {
                toastr.success($translate.instant('customer.updated'));
                vm.customer = result.data;
                if(vm.customer.birthDate) {
                    vm.customer.birthDateText = moment.utc(vm.customer.birthDate).format(vm.DATE_FORMAT).toString();
                }
                vm.cancelEditMode();
            }, function (error) {
                if (error.data.headers["x-adminapp-params"]) {
                    toastr.error($translate.instant(error.data.headers["x-adminapp-params"].concat(".").concat(error.data.headers["x-adminapp-error"])));
                } else {
                    toastr.error($translate.instant("global.messages.somethingWrong"));
                }
            });
        }

        function loadCustomerData() {
            if (vm.isCreateMode) {
                vm.customerEdit = angular.copy(vm.customer);
                loadNotesTags();
            } else {
                var birthDate = vm.customer.birthDateInDate || vm.customer.birthdate;

                if (birthDate) {
                    vm.customer.birthDate = moment(birthDate).toDate();
                    vm.customer.birthDateText = moment.utc(birthDate).format(vm.DATE_FORMAT).toString();
                } else {
                    vm.customer.birthDate = null;
                    vm.customer.birthDateText = null;
                }

                if (vm.customer.phone) {
                    vm.customer.phone = addNine(vm.customer.phone);
                }
                loadNotesTags(vm.customer.id);
            }
        }

        function loadNotesTags(customerId) {
            if (customerId) {
                NoteTagService.getNotesTags(customerId).then(
                    function (notesTags) {
                        vm.notes = notesTags.filter(function (noteTag) {
                            noteTag.timestamp = moment(noteTag.timestamp).format(DATETIME_FORMAT);
                            if (noteTag.id && noteTag.type === TAG_NOTE_MAP.NOTE) {
                                return true;
                            }
                        });

                        vm.tags = notesTags.filter(function (noteTag) {
                            if (noteTag.id && noteTag.type === TAG_NOTE_MAP.TAG) {
                                return true;
                            }
                        });
                    }
                );
            }

            NoteTagService.getNotesTagsByStore().then(
                function (notesTags) {
                    vm.storeTags = notesTags.filter(function (noteTag) {
                        if (noteTag.id && noteTag.type === TAG_NOTE_MAP.TAG) {
                            return true;
                        }
                    });

                    vm.filteredStoreTags = vm.storeTags.filter(function(noteTag, index, self) {
                        if (!noteTag.id || noteTag.type !== TAG_NOTE_MAP.TAG) {
                            return false;
                        }

                        const firstIndex = self.findIndex(function(t) {
                            return t.text && noteTag.text &&
                                t.text === noteTag.text;
                        });

                        return index === firstIndex;
                    });
                }
            );
        }
    }
})();
